import { Theme } from '@mui/material';

export const styles = {
  title: {
    fontSize: 24,
    lineHeight: '32px',
    textAlign: 'center',
    color: 'primary.main',
  },
  subTitle: {
    fontSize: 16,
    lineHeight: '24px',
    textAlign: 'center',
    color: 'primary.main',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    my: 1,
  },
  paperInfo: {
    borderTop: ({ palette }: Theme) => `4px solid ${palette.green.fruitSalad}`,
  },
  paperWarning: {
    borderTop: ({ palette }: Theme) => `4px solid ${palette.red.main}`,
  },
  submitButton: {
    boxShadow: 'none',
    height: 48,
    width: 140,
    py: 1,
    px: 3,
    backgroundColor: 'green.fruitSalad',
    '&:hover': {
      backgroundColor: 'green.fruitSalad80',
    },
  },
  disabledText: {
    color: 'grey.main',
  },
  closeIcon: {
    position: 'absolute',
    right: 10,
    top: 10,
    cursor: 'pointer',
  },
} as const;
